"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const PageContexts_1 = require("./Contexts/PageContexts");
const GridWrapper = ({ controlMap, componentType, forceOneColumn, isOneElement, columnSpan, columns, allowDynamicSizing, children, isDesktopCard, hidden }) => {
    const { isVisible } = (0, PageContexts_1.useFieldVisibility)();
    return (react_1.default.createElement(controlMap.GridElementWrapper, { columnSpan: isVisible && !hidden ? columnSpan : 0, columns: forceOneColumn ? 1 : columns, allowDynamicSizing: allowDynamicSizing, type: componentType, noMargins: isOneElement && componentType === 'aggregateMap', isOneElement: isOneElement, isDesktopCard: isDesktopCard }, children));
};
exports.default = GridWrapper;
